import React from 'react'
import * as Yup from 'yup'

import { TtButton, TtCard } from '@23/ui-react'
import * as TtForms from '@23/react-forms'

import type { WidgetDTO } from '../../../../../../model/Widget'

const hubspotSchema = Yup.object({
  link: Yup.string()
    .trim()
    .transform((v) => (v === '' ? undefined : v))
    .required('HubSpot calendar URL is required')
    .url('Invalid URL format'),
})

type FormValues = Yup.InferType<typeof hubspotSchema>

interface HubspotEditModeProps {
  widget: WidgetDTO
  onSave: (values: FormValues) => Promise<void>
  onCancel: () => void
}

const HubspotEditMode = ({
  widget,
  onSave,
  onCancel,
}: HubspotEditModeProps) => (
  <TtCard
    className="personal-widget-hubspot personal-widget-hubspot--edit"
    hideLabel
  >
    <TtForms.Form<FormValues>
      className="personal-widget-hubspot-form"
      label="Edit HubSpot calendar URL"
      initialValues={{
        link: widget.link ?? '',
      }}
      validationSchema={hubspotSchema}
      onSubmit={onSave}
      enableReinitialize
    >
      <TtForms.TextField<FormValues>
        name="link"
        label="HubSpot calendar link"
        placeholder="HubSpot calendar link"
      />
      <p className="personal-widget-hubspot-hint">
        Make sure embedding is enabled on HubSpot for your calendar.
      </p>
      <div className="personal-widget-hubspot-form-actions">
        <TtButton variant="outline" color="secondary" onClick={onCancel}>
          Cancel
        </TtButton>
        <TtForms.SubmitButton color="primary" disabled={false}>
          Save
        </TtForms.SubmitButton>
      </div>
    </TtForms.Form>
  </TtCard>
)

export { type FormValues as HubspotFormValues, HubspotEditMode }
